(function ($) {
  $(document).ready(function(){
    $('.accordion__item-title').click(function(event) {
      event.preventDefault();
      $(this).toggleClass('open');
      $accordion_title = $(this);
      $accordion_content = $(this).next('.faq_content_wrapper');
      $('.faq_content_wrapper').not($accordion_content).slideUp();
      $('.faq_content_wrapper').not($accordion_content).prev('.accordion-title').removeClass('open');
      $accordion_content.stop(true, true).slideToggle(400);
      $('.bp-accordion .svg-inline--fa').removeClass('fa-minus').addClass('fa-plus');
      //Now just add it for 'this'
      $(this).children('.svg-inline--fa').addClass('fa-minus');
      if ($(this).hasClass('open')) {
        $(this).children('.svg-inline--fa').addClass('fa-minus');
      } else {
        $(this).children('.svg-inline--fa').addClass('fa-plus').removeClass('fa-minus');
      }
    });
  });
})(jQuery);
